import React, { useState, useEffect } from 'react';
import lic1 from './assets/lic1.jpg';
import lic2 from './assets/lic2.jpg';
import styles from './License.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Meta from './Meta';

const licenses = [
  { id: 1, src: lic1, alt: 'Лицензия 1' },
  { id: 2, src: lic2, alt: 'Лицензия 2' },
];

export function License() {
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const openModal = (src) => setSelectedImg(src);
  const closeModal = () => setSelectedImg(null);

  return (
      <React.Fragment>
      <Meta
         title="Официальные лицензии IT-провайдера «ИТ Особа»"
         description="«ИТ Особа» работает на законных основаниях. Вся деятельность лицензирована."
       />
    <div className={styles.container}>
      <h2 className={styles.title} data-aos="fade-down">Лицензии:</h2>
      <p className={styles.text} data-aos="fade-up" data-aos-delay="100">
        Наша компания обладает всеми необходимыми лицензиями и разрешительными документами. При постройке сети оформляются все необходимые проекты и согласования, что исключает риск возникновения спорных вопросов и дополнительно гарантирует предоставление услуг в бесперебойном режиме.
        Также размещены документы.
      </p>
      <div style={{ 
        margin: '25px 0', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '10px',
        fontSize: '1.1em',
        fontWeight: '600',
        color: '#0057b7', // Цвет в стиле заголовка
        paddingLeft: '10px' // Небольшой отступ слева
      }} data-aos="fade-up" data-aos-delay="150">
        <span>Л030-00114-77/00050071</span>
        <span>Л030-00114-77/00050070</span>
        <span>Л030-00114-77/00050072</span>
      </div>
      {/* <div className={styles.licensesWrapper}>
        {licenses.map(({ id, src, alt }) => (
          <img
            key={id}
            src={src}
            alt={alt}
            className={styles.licenseImg}
            onClick={() => openModal(src)}
            data-aos="zoom-in"
            data-aos-delay={id * 100}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>

      {selectedImg && (
        <div className={styles.modalBackground} onClick={closeModal} data-aos="fade-in">
          <img
            src={selectedImg}
            alt="Увеличенное изображение лицензии"
            className={styles.modalImg}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )} */}
    </div>
    </React.Fragment>
  );
}